import React, { useState } from 'react'
import { Button, Row, Col } from 'antd';
import LogoImg from '../../assets/img/Playarone_primary_light.svg'
import groupedImg from '../../assets/img/Group_user.svg'
import curve from '../../assets/img/curve.svg'
import moneyIcon from '../../assets/img/naira.svg'
import './playarone_card.css'

const PlayarOneCard = () =>{

    const [activeTab, setActiveTab] = useState('1');

    return(
        <div className="playar_one_sec">
            <Row gutter={[16, 24]}>
                <Col xs={{ span: 24 }} sm={{ span: 14, offset: 6 }} md={{ span: 12 }} lg={{ span: 10, offset: 2 }} xl={{ span: 7, offset: 2 }} className="left">
                    <div className="playar_one_card">
                        <div className="card_top">
                            <img src={LogoImg} alt="" />
                            <img src={curve} alt="" />
                            <h2>Tournaments</h2>
                            <div className="games_name">
                                <ul>
                                    <li> <Button className={activeTab === '1' ? 'active' : ''} onClick={() => setActiveTab('1')}>windows</Button> </li>
                                    <li> <Button className={activeTab === '2' ? 'active' : ''} onClick={() => setActiveTab('2')}>xbox one</Button> </li>
                                    <li> <Button className={activeTab === '3' ? 'active' : ''} onClick={() => setActiveTab('3')}>playstation</Button> </li>
                                </ul>
                            </div>
                        </div>
                        <div className="card_bottom">
                            <div className={`tabPanel ${activeTab === '1' ? 'active' : ''}`}>
                                <div className="card_bottom_holder">
                                    <div className="content_container">
                                        <img src={moneyIcon} alt="" />
                                        <div className="content_det">
                                            <p>₦ 125,500</p>
                                            <h6>Cash Awarded</h6>
                                        </div>
                                    </div>
                                    <div className="content_container">
                                        <img src={moneyIcon} alt="" />
                                        <div className="content_det">
                                            <p>1320</p>
                                            <h6>Games Played</h6>
                                        </div>
                                    </div>
                                </div>
                                <div className="card_bottom_holder">
                                    <div className="content_container">
                                        <img src={moneyIcon} alt="" />
                                        <div className="content_det">
                                            <p>502,456</p>
                                            <h6>Points Earned</h6>
                                        </div>
                                    </div>
                                    <div className="content_container">
                                        <img src={moneyIcon} alt="" />
                                        <div className="content_det">
                                            <p>772</p>
                                            <h6>Tournaments</h6>
                                        </div>
                                    </div>
                                </div>
                                <div className="card_bottom_footer">
                                    <div className="footer_content">
                                        <div className="footer_det">
                                            <p>Players</p>
                                            <h4>669</h4>
                                        </div>
                                        <img src={groupedImg} alt="" />
                                    </div>
                                </div>
                            </div>
                            <div className={`tabPanel ${activeTab === '2' ? 'active' : ''}`}>
                                <div className="card_bottom_holder">
                                    <div className="content_container">
                                        <img src={moneyIcon} alt="" />
                                        <div className="content_det">
                                            <p>₦ 125,500</p>
                                            <h6>Cash Awarded</h6>
                                        </div>
                                    </div>
                                    <div className="content_container">
                                        <img src={moneyIcon} alt="" />
                                        <div className="content_det">
                                            <p>1320</p>
                                            <h6>Games Played</h6>
                                        </div>
                                    </div>
                                </div>
                                <div className="card_bottom_holder">
                                    <div className="content_container">
                                        <img src={moneyIcon} alt="" />
                                        <div className="content_det">
                                            <p>502,456</p>
                                            <h6>Points Earned</h6>
                                        </div>
                                    </div>
                                    <div className="content_container">
                                        <img src={moneyIcon} alt="" />
                                        <div className="content_det">
                                            <p>772</p>
                                            <h6>Tournaments</h6>
                                        </div>
                                    </div>
                                </div>
                                <div className="card_bottom_footer">
                                    <div className="footer_content">
                                        <div className="footer_det">
                                            <p>Players</p>
                                            <h4>203</h4>
                                        </div>
                                        <img src={groupedImg} alt="" />
                                    </div>
                                </div>
                            </div>
                            <div className={`tabPanel ${activeTab === '3' ? 'active' : ''}`}>
                                <div className="card_bottom_holder">
                                    <div className="content_container">
                                        <img src={moneyIcon} alt="" />
                                        <div className="content_det">
                                            <p>₦ 125,500</p>
                                            <h6>Cash Awarded</h6>
                                        </div>
                                    </div>
                                    <div className="content_container">
                                        <img src={moneyIcon} alt="" />
                                        <div className="content_det">
                                            <p>1320</p>
                                            <h6>Games Played</h6>
                                        </div>
                                    </div>
                                </div>
                                <div className="card_bottom_holder">
                                    <div className="content_container">
                                        <img src={moneyIcon} alt="" />
                                        <div className="content_det">
                                            <p>502,456</p>
                                            <h6>Points Earned</h6>
                                        </div>
                                    </div>
                                    <div className="content_container">
                                        <img src={moneyIcon} alt="" />
                                        <div className="content_det">
                                            <p>772</p>
                                            <h6>Tournaments</h6>
                                        </div>
                                    </div>
                                </div>
                                <div className="card_bottom_footer">
                                    <div className="footer_content">
                                        <div className="footer_det">
                                            <p>Players</p>
                                            <h4>1000</h4>
                                        </div>
                                        <img src={groupedImg} alt="" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Col>
                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24}} lg={{ span: 8, offset: 4 }} xl={{ span: 8, offset: 4 }} className="right">
                    <h2>A New Whole <br />
                    Gaming Tournaments</h2>
                    <p>Play anywhere. Join anytime.</p>
                    <Button type="primary">SEE ALL</Button>
                </Col>
            </Row>
        </div>
    );
}

export default PlayarOneCard;